import { useTheme } from "@/src/hooks/useTheme";

/**
 * Icône de l'application, déclinée selon le fond sur lequel elle se pose.
 *
 * Les deux fichiers de `public/` ne diffèrent que par un hexagone : blanc cassé
 * dans `LauncherIcon.png` (pour un fond sombre), encre dans
 * `LauncherIcon-light.png` (pour un fond clair). Le violet et l'ambre, eux, ne
 * bougent pas.
 *
 * @param onDarkSurface - force la déclinaison « fond sombre », pour les zones
 *   qui restent sombres quel que soit le thème (le panneau de marque de la
 *   page de connexion). Par défaut, l'icône suit le thème.
 */
export function AppLogo({
  className,
  onDarkSurface = false,
}: {
  className?: string;
  onDarkSurface?: boolean;
}) {
  const { theme } = useTheme();
  const useDarkSurfaceVariant = onDarkSurface || theme === "dark";

  return (
    <img
      alt=""
      className={className}
      src={
        useDarkSurfaceVariant ? "/LauncherIcon.png" : "/LauncherIcon-light.png"
      }
    />
  );
}
